import type { SubMenuUploadFileType } from '@core/core/types'
import type { FallbackAcceptsObject } from 'file-system-access/lib/showOpenFilePicker'

export const uploadFilesExtensions = {
  Survey2D: ['.sgy', '.segy'],
  Survey3D: ['.sgy', '.segy'],
}

// Not implemented: Stick, RIGIS, WellheadCoordinates, Inclinometry, GIS, Markers, VSP, Attribute
// Therefor in these cases the default configuration of the file picker will be applied (described at the end of the file)
// TODO Remove Partial
const configNative: Partial<Record<SubMenuUploadFileType, OpenFilePickerOptions>> = {
  Survey2D: {
    types: [
      {
        description: 'Съемка 2D(SEG-Y seismic data)',
        accept: { 'application/seismic-segy': uploadFilesExtensions.Survey2D },
      },
    ],
    excludeAcceptAllOption: true,
    multiple: true,
  },
  Survey3D: {
    types: [
      {
        description: 'Съемка 3D(SEG-Y seismic data)',
        accept: { 'application/seismic-segy': uploadFilesExtensions.Survey3D },
      },
    ],
    excludeAcceptAllOption: true,
    multiple: true,
  },
  Horizon: {
    types: [],
    excludeAcceptAllOption: false,
    multiple: true,
  },
  Fault: {
    types: [],
    excludeAcceptAllOption: false,
    multiple: true,
  },
  Maps: {
    types: [
      {
        description: 'Карта(Irap classic grid)',
        accept: {
          'application/x-ogc-irap': ['.irap', '.grd'],
        },
      },
      {
        description: 'Карта(CPS-3 grid)',
        accept: {
          'application/x-ogc-csp3': ['.csp3', '.grd'],
        },
      },
    ],
    excludeAcceptAllOption: false,
    multiple: true,
  },
  Polygons: {
    types: [
      {
        description: 'Полигоны(Irap classic grid)',
        accept: {
          'application/x-ogc-irap': ['.irap'],
        },
      },
      {
        description: 'Полигоны(CPS-3 grid)',
        accept: {
          'application/x-ogc-csp3': ['.csp3'],
        },
      },
    ],
    excludeAcceptAllOption: false,
    multiple: true,
  },
  VSP: {
    types: [
      {
        description: 'Checkshots format (ASCII)',
        accept: {
          'text/plain': ['.dat'],
        },
      },
    ],
    excludeAcceptAllOption: false,
  },
  Markers: {
    types: [
      {
        description: 'Маркеры format (ASCII)',
        accept: {
          'text/plain': ['.dat'],
        },
      },
    ],
    excludeAcceptAllOption: false,
    multiple: true,
  },
}
export const config = Object.fromEntries(
  Object.entries(configNative).map(([key, value]) => {
    const accepts: FallbackAcceptsObject[] =
      value.types?.flatMap(type => {
        return Object.entries(type.accept).map(([mimeType, rawExtensions]) => {
          const extensions = Array.isArray(rawExtensions) ? rawExtensions : [rawExtensions]

          return {
            extensions: extensions.map(extension => extension.replace('.', '')),
            mimeTypes: [mimeType],
          }
        })
      }) ?? []

    const updatedValue = { ...value, accepts }
    return [key, updatedValue]
  }),
)

export const defaultFilePickerConfig: OpenFilePickerOptions = {
  types: [
    {
      description: 'Любой тип файла',
      accept: {
        'text/plain': [],
      },
    },
  ],
  excludeAcceptAllOption: false,
  multiple: true,
}

export type OpenFilePickerConfigType = keyof typeof configNative
